import { inject, injectable } from "@launchtray/tsyringe-async";
import { SceneManager } from "../../../../../scene/SceneManager";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { IBuildingRankUpController } from "./IBuildingRankUpController";
import { LandlordRenterInfoPopupScene } from "../../landlordrenterinfo/LandlordRenterInfoPopupScene";
import { AsyncOperationNotification } from "../../../common/components/AsyncOperationNotification";

@injectable()
export class BuildingRankUpController implements IBuildingRankUpController {
    private readonly playerModel: IPlayerModel;
    private readonly sceneManager: SceneManager;
    private readonly landlordRenterInfoPopupScene: () => Promise<LandlordRenterInfoPopupScene>;
    private readonly asyncOperationNotification: AsyncOperationNotification;

    public constructor(
        @inject("LandlordRenterInfoPopupSceneFactory") landlordRenterInfoPopupScene: () => Promise<LandlordRenterInfoPopupScene>,
        @inject("IPlayerModel") playerModel: IPlayerModel,
        sceneManager: SceneManager,
        asyncOperationNotification: AsyncOperationNotification
    ) {
        this.landlordRenterInfoPopupScene = landlordRenterInfoPopupScene;
        this.playerModel = playerModel;
        this.sceneManager = sceneManager;
        this.asyncOperationNotification = asyncOperationNotification;
    }

    public collectCoins(value: number): void {
        this.playerModel.addCoins(value);
    }

    public async landlordRenterInfoPopup(): Promise<void> {
        const scene = await this.asyncOperationNotification.autoShowHide(this.landlordRenterInfoPopupScene());
        await this.sceneManager.showViewableAsync(scene);
    }
}
